import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "components/ui/Select";
import SelectCustomers from "components/ui/selectors/SelectCustomers";
import Input from "components/ui/Input";
import {
  useAllSchemeMasters,
  useGenerateSchemePendingOrders,
} from "http-hooks/schemeMaster/useSchemeMaster";
import { getDocumentUrls, getDocumentViewerRoute } from "utils/documentUrlHelper";

const SchemePendingOrders = () => {
  const navigate = useNavigate();
  const [selectedScheme, setSelectedScheme] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [asOnDate, setAsOnDate] = useState("");

  const { data: schemesData, isLoading: loadingSchemes } =
    useAllSchemeMasters({ noPagination: true });

  const { mutateAsync: generateReport, isPending: isGenerating } =
    useGenerateSchemePendingOrders();

  const schemeOptions =
    schemesData?.data?.map((scheme) => ({
      value: scheme.schemeid,
      label: `${scheme.sch_name} | ${scheme.vendorDetail?.name || scheme.vendor}`,
    })) || [];

  const handleGenerateReport = async () => {
    try {
      const filters = {};
      if (selectedScheme) filters.schmId = selectedScheme.value;
      if (selectedCustomer) filters.custid = selectedCustomer.ps_Id;
      if (asOnDate) filters.asOnDate = asOnDate;

      const data = await generateReport(filters);
      const { htmlUrl, pdfUrl } = getDocumentUrls(data);

      navigate(
        getDocumentViewerRoute("pending", {
          htmlUrl,
          pdfUrl,
          documentNumber: "Scheme Pending",
          documentType: "Scheme Pending Orders",
        })
      );
    } catch (error) {
      console.error("Error generating report:", error);
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-semibold leading-6 text-gray-900 text-center">
        Scheme Pending Orders
      </h1>

      <div className="max-w-md mx-auto mt-6 space-y-4">
        <Select
          label="Scheme"
          options={schemeOptions}
          value={selectedScheme}
          onChange={setSelectedScheme}
          placeholder="All Schemes"
          isLoading={loadingSchemes}
          isSearchable={true}
          isClearable={true}
        />

        <SelectCustomers
          label="Customer"
          value={selectedCustomer}
          onChange={setSelectedCustomer}
          isClearable={true}
        />

        <Input
          label="As On Date"
          type="date"
          value={asOnDate}
          onChange={(e) => setAsOnDate(e.target.value)}
          now={true}
        />

        <div className="flex justify-center pt-2">
          <button
            type="button"
            onClick={handleGenerateReport}
            disabled={isGenerating}
            className="rounded-md bg-indigo-600 px-8 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isGenerating ? "Generating..." : "Generate Report"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SchemePendingOrders;
